import CartItem from './Item'
import CartTotal from './CartTotal'
import { useMemo } from 'react';
import { getFoodyById } from '../../utils/functions';
import { useStateValue } from '../../context/StateProvider';

const CartBody = ({action}:{action:any}) => {
  const [{cartItems, foodItems, categories}] = useStateValue();

  // Resolved once for the whole cart rather than inside each row.
  const categoryNameByType = useMemo(() => {
    const map: Record<string, string> = {};
    (categories || []).forEach((c: any) => {
      if (c?.categoryType) map[c.categoryType] = String(c.title || '').trim();
    });
    return map;
  }, [categories]);
  return (
    <div className='w-full h-full rounded-t-[2rem]  bg-cartBg flex flex-col'>
        <div className='w-full h-[340px] md:h-42 px-6 py-10 flex flex-col gap-3 overflow-y-scroll scrollbar-hidden'>
        {
          cartItems && cartItems.length > 0 && cartItems.map((item:any, index:number) => {
            const food = getFoodyById(foodItems, item?.fid);
            return (
              <CartItem
                key={index}
                item={item}
                categoryName={categoryNameByType[(food as any)?.category]}
              />
            )
          } )
        }
        </div>
        <CartTotal checkoutState={action} />
    </div>
  )
}

export default CartBody